import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, error, clearError } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    console.log('📝 Formulário submetido:', { username, password: password ? '***' : 'empty' });
    
    if (!username || !password) {
      console.log('⚠️ Dados incompletos - interrompendo login');
      return;
    }

    try {
      console.log('🔄 Iniciando processo de login...');
      setIsLoading(true);
      await login(username, password);
      console.log('✅ Login realizado com sucesso - redirecionando para dashboard');
      navigate('/dashboard');
    } catch (err) {
      console.log('❌ Erro no login:', err);
      // Erro já é tratado pelo contexto
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = () => {
    if (error) {
      clearError();
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="login-header">
          <div className="login-icon">
            <i className="radio-icon">📻</i>
          </div>
          <h1>Radio Itajaí</h1>
          <p>Painel Administrativo</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form-content">
          <div className="form-group">
            <label htmlFor="username">Usuário</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                handleInputChange();
              }}
              placeholder="Digite seu usuário"
              required
              autoComplete="username"
              disabled={isLoading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                handleInputChange();
              }}
              placeholder="Digite sua senha"
              required
              autoComplete="current-password"
              disabled={isLoading}
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading || !username || !password}
          >
            {isLoading ? (
              <>
                <div className="spinner"></div>
                Entrando...
              </>
            ) : (
              <>
                <i className="login-icon">🔑</i>
                Entrar
              </>
            )}
          </button>
        </form>
        
        {error && (
          <div className="error-message">
            <i className="error-icon">⚠️</i>
            {error}
          </div>
        )}
        
        
      </div>
    </div>
  );
};

export default Login; 